
import React, { useState, useEffect } from 'react';
import { message, Button } from 'antd';
import axios from 'axios';
import * as XLSX from 'xlsx';
import Fetchtable from '../components/Fetchtable';

const URL = process.env.REACT_APP_API_URL;

const RecruitmentsReport = () => {

    const [reloadData, setReloadData] = useState(false);

    const userColumns = [
        {
            name: 'Sr. No',
            // selector: (row) => row.fullName,
            cell: (row, index) => (
                <div style={{ textAlign: 'center' }}>
                    {index + 1}
                </div>
            ),
            sortable: true,
            width: '180px',
        },
        {
            name: 'Date of Request',
            selector: (row) => new Date(row.postedAt),
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {new Date(row.postedAt).toLocaleDateString()}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Requestor',
            selector: (row) => row.postedBy,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.postedBy}
                </div>
            ),
            sortable: true,
        },
        {
            name: 'Leadership Approval Shared',
            selector: (row) => row.status,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.status === 'REQ Approved' ? 'Yes' : 'No'}
                </div>
            ),
            width: '230px',
        },
        {
            name: 'Vertical',
            selector: (row) => row.vertical,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.vertical}
                </div>
            ),
        },
        {
            name: 'Department',
            selector: (row) => row.department,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.department}
                </div>
            ),
        },
        {
            name: 'Skill',
            selector: (row) => row.primarySkills,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.primarySkills.join(', ')}
                </div>
            ),
            sortable: true,
            width: '250px',
        },
        {
            name: 'Title',
            selector: (row) => row.position,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.position}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Location',
            selector: (row) => row.jobLocation,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.jobLocation}
                </div>
            ),
            sortable: true,
            width: '250px',
        },
        {
            name: 'Ageing(days)',
            // selector: (row) => row.selected,
            cell: (row) => {
                const posted = new Date(row.postedAt);
                const created = new Date(row.createdAt);

                // Difference in milliseconds
                const diffMs = created - posted;

                // Convert to days
                const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

                return (
                    <div>
                        {diffDays}
                    </div>
                );
            },
            sortable: true,
            width: '190px',
        },
        {
            name: 'Candidate Name',
            selector: (row) => row.fullName,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.fullName}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Email',
            selector: (row) => row.email,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.email}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Contact)',
            selector: (row) => row.contact,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.contact}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Source',
            selector: (row) => row.source,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.source}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Total Experience',
            selector: (row) => row.totalExperience,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.totalExperience}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Relevant Experience',
            selector: (row) => row.relevantExperience,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.relevantExperience}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Highest Degree',
            selector: (row) => row.qualification,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.qualification}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Current Salary',
            selector: (row) => row.salary,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.salary}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Expected Salary',
            selector: (row) => row.expectedSalary,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.expectedSalary}
                </div>
            ),
            sortable: true,
            width: '190px',
        },
        {
            name: 'Offer Acceptance Status',
            selector: (row) => row.candidateStatus,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.candidateStatus === 'Joined'? 'Accepted': ''}
                </div>
            ),
            sortable: true,
            width: '230px',
        },
        {
            name: 'Date Of Joining',
            selector: (row) => row.joiningDate,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {new Date(row.joiningDate).toLocaleDateString()}
                </div>
            ),
            sortable: true,
            width: '230px',
        },
        {
            name: 'Candidate Final Status',
            selector: (row) => row.candidateStatus,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.candidateStatus}
                </div>
            ),
            sortable: true,
            width: '230px',
        },
        {
            name: 'Comments',
            // selector: (row) => row.mgrName,
            cell: (row) => (
                <div>
                    {''}
                </div>
            ),
            sortable: true,
            width: '230px',
        },
        {
            name: 'Recruiter Name',
            selector: (row) => row.mgrName,
            cell: (row) => (
                <div style={{ textTransform: 'capitalize' }}>
                    {row.mgrName}
                </div>
            ),
            sortable: true,
            width: '230px',
        },
    ]

    return (
        <>
            <div>
                <br /><br /><br /><br /><br /><br />
                <h1>Welcome to Recruitments Report Tab</h1>
                <Fetchtable
                    url={`${URL}/api/getRecruitementsData`}
                    columns={userColumns}
                    // setSelectedCandidate={setSelectedCandidate}
                    reloadData={reloadData}
                    fileName="Recruitments Report"
                // filterOption={filterOption}
                />
            </div>
        </>
    )

}

export default RecruitmentsReport;